import { Loader2 } from 'lucide-react';
import { useI18n } from '@/lib/i18n';

export function LoadingScreen({ label }) {
  const { t } = useI18n();
  const text = label || t('common.loading');
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-asgym-sub" data-testid="loading-screen">
      <Loader2 className="animate-spin text-asgym-accent" size={26} />
      <span className="text-xs font-bold tracking-widest uppercase">{text}</span>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, sub, action }) {
  return (
    <div className="as-card flex flex-col items-center gap-3 px-6 py-12 text-center" data-testid="empty-state">
      {Icon && (
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/[0.06] bg-white/[0.03]">
          <Icon className="text-asgym-sub" size={24} />
        </div>
      )}
      {title && <p className="text-sm font-bold text-asgym-text">{title}</p>}
      {sub && <p className="max-w-[280px] text-[13px] leading-relaxed text-asgym-sub">{sub}</p>}
      {action}
    </div>
  );
}
